import type { PromptSettings, PromptType, PromptVersionHistoryResponse } from "@/schema/prompt"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export interface PromptUpdateParams {
  contentJson?: Record<string, string>
  settings?: {
    recommendTasks?: boolean
  }
}

export function fetchPrompts(context: ApiContext): Promise<{ prompts: PromptSettings[] }> {
  return apiContextFetch<{ prompts: PromptSettings[] }>(context, "prompts")
}

export function createPromptRun(context: ApiContext, promptableId: string, promptType: PromptType) {
  return apiContextFetch<void>(context, "prompt_runs", {
    method: "POST",
    body: JSON.stringify({
      prompt_run: {
        promptable_id: promptableId,
        prompt_type: promptType,
      },
    }),
  })
}

export function updatePrompt(
  context: ApiContext,
  id: string,
  params: PromptUpdateParams
): Promise<{ prompt: PromptSettings }> {
  const payload = {
    prompt: {
      ...(params.contentJson !== undefined && { content_json: params.contentJson }),
      ...(params.settings !== undefined && { settings: { recommend_tasks: params.settings?.recommendTasks } }),
    },
  }
  return apiContextFetch<{ prompt: PromptSettings }>(context, `prompts/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  })
}

export function fetchPromptVersions(
  context: ApiContext,
  promptId: string,
  key?: string
): Promise<PromptVersionHistoryResponse> {
  const queryParams = new URLSearchParams()
  if (key) {
    queryParams.set("key", key)
  }

  const path =
    queryParams.size > 0 ? `prompts/${promptId}/versions?${queryParams.toString()}` : `prompts/${promptId}/versions`
  return apiContextFetch<PromptVersionHistoryResponse>(context, path)
}
